import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { Modal } from '../../../UiKit';
import { MoreOrderedItems } from '../../popups';
import './BatchedOrder.scss';

export default class BatchedOrder extends Component {
  render() {
    const { data } = this.props;

    return (
      <div className='batchedOrderContainer'>
        {!data ? (
          <Shimmer height='150px' width='100%' />
        ) : (
          <BatchedOrderComp {...this.props} />
        )}
      </div>
    );
  }
}

class BatchedOrderComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreItems: false,
    };
  }

  showMoreItems = () => {
    this.setState({
      showMoreItems: true,
    });
  };

  renderItemsList = (items) => {
    const orderedItems = Object.keys(items);
    const orderedItemsList = orderedItems.slice(0, 2);
    orderedItems.splice(0, 2);
    return orderedItemsList.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <li>
            <p>
              {items[item].quantity} x {items[item].name}
            </p>
          </li>
          {index === 1 && orderedItems.length ? (
            <li>
              <p className='dark moreOrderedItems'>
                <span
                  className='greenBottomBorder'
                  onClick={this.showMoreItems.bind(this)}
                >
                  + {orderedItems.length} more items
                </span>
              </p>
            </li>
          ) : null}
        </React.Fragment>
      );
    });
  };

  hideMoreItems = () => {
    this.setState({
      showMoreItems: false,
    });
  };

  render() {
    const { data } = this.props;
    const { showMoreItems } = this.state;
    if (!data) return null;

    return (
      <div className='orderBox col'>
        <p className='orderHeader dark large'>{data.title}</p>
        <div>
          {data.orders &&
            data.orders.map((ele, index) => (
              <React.Fragment key={index}>
                <div className='itemsList col pt10'>
                  <p className='lighter'>Order #{ele.order_id}</p>
                  <ul>{this.renderItemsList(ele.items)}</ul>
                </div>
                <Modal
                  isVisible={showMoreItems}
                  title='Items Ordered'
                  handleClose={this.hideMoreItems.bind(this)}
                  component={<MoreOrderedItems items={ele.items} />}
                />
              </React.Fragment>
            ))}
        </div>
      </div>
    );
  }
}
